module.exports = __webpack_public_path__ + "img/4aad195.svg";